import {
  Backup,
  Dashboard,
  DashboardCustomize,
  EmojiEvents,
  Grade,
  GroupWork,
  ListAlt,
  Palette,
  Person,
  Lock,
  Download,
  Description,
  SettingsRemote,
  Mic,
} from "@mui/icons-material";
import type { ReactNode } from "react";
import dico from "src/shared/util/src/language/dico";
import type { PortalHomeTab } from "./PortalShell";
import type { PortalNavGroup } from "./portalTypes";

export type LicensedNavCapabilities = {
  planning: boolean;
  backup: boolean;
  layoutEditor: boolean;
  controlRoom: boolean;
  speaker: boolean;
};

/** Builds licensed sidebar groups filtered by licence / role capabilities. */
export function buildLicensedPortalNav(caps: LicensedNavCapabilities): {
  homeTab: PortalHomeTab;
  navGroups: PortalNavGroup[];
} {
  const nav = dico().portalNav;
  const homeTab: PortalHomeTab = {
    id: "home",
    label: nav.items.dashboard,
    icon: <Dashboard />,
    path: "/licensed",
  };
  const item = (
    id: string,
    path: string,
    label: string,
    icon: ReactNode,
    visible = true,
  ) => ({ id, path, label, icon, visible });
  const navGroups: PortalNavGroup[] = [
    {
      id: "home",
      label: nav.groups.home,
      items: [
        item("home", "/licensed", nav.items.dashboard, <Dashboard />),
        item("profile", "/licensed/profile", nav.items.profile, <Person />),
        item("license", "/licensed/license", nav.items.myLicense, <Lock />),
        item(
          "installer",
          "/licensed/installer",
          nav.items.installer,
          <Download />,
        ),
        item(
          "accepted-terms",
          "/licensed/accepted-terms",
          nav.items.acceptedTerms,
          <Description />,
        ),
      ],
    },
    {
      id: "competition",
      label: nav.groups.competition,
      items: [
        item("my-meets", "/licensed/my-meets", nav.items.myMeets, <ListAlt />),
        item(
          "my-records",
          "/licensed/my-records",
          nav.items.myRecords,
          <EmojiEvents />,
        ),
        item("my-levels", "/licensed/my-levels", nav.items.myLevels, <Grade />),
        item(
          "my-referees",
          "/licensed/my-referees",
          nav.items.myReferees,
          <GroupWork />,
          caps.planning,
        ),
        item(
          "backups",
          "/licensed/backups",
          nav.items.backups,
          <Backup />,
          caps.backup,
        ),
      ],
    },
    {
      id: "display",
      label: nav.groups.display,
      items: [
        item(
          "layouts",
          "/licensed/layouts",
          nav.items.layouts,
          <DashboardCustomize />,
          caps.layoutEditor,
        ),
        item(
          "themes",
          "/licensed/themes",
          nav.items.themes,
          <Palette />,
          caps.layoutEditor,
        ),
        item(
          "control-room",
          "/licensed/control-room",
          nav.items.controlRoom,
          <SettingsRemote />,
          caps.controlRoom,
        ),
      ],
    },
    {
      id: "speaker",
      label: nav.groups.speaker,
      items: [
        item(
          "speaker-landing",
          "/speaker",
          nav.items.speakerLanding,
          <Mic />,
          caps.speaker,
        ),
      ],
    },
  ];
  return { homeTab, navGroups };
}
